import { Security } from './entities';
import { QuoteFeedExtended } from './feed';
export class QuoteStore {
  private quoteFeeds = new Map<Security, QuoteFeedExtended>();
  private activeQuoteFeeds = new Set<QuoteFeedExtended>();

  public addQuoteFeed = (quoteFeed: QuoteFeedExtended): QuoteFeedExtended => {
    this.quoteFeeds.set(quoteFeed.getSecurities(), quoteFeed);
    return quoteFeed;
  };

  public removeQuoteFeed = (symbol: Security): void => {
    this.quoteFeeds.delete(symbol);
  };

  public addActiveQuoteFeed = (quoteFeed: QuoteFeedExtended): QuoteFeedExtended => {
    this.activeQuoteFeeds.add(quoteFeed);
    return quoteFeed;
  };

  public removeActiveQuoteFeed = (quoteFeed: QuoteFeedExtended): void => {
    this.activeQuoteFeeds.delete(quoteFeed);
  };

  public getQuoteFeeds = (): QuoteFeedExtended[] => {
    return Array.from(this.quoteFeeds.values());
  };

  public getActiveQuoteFeeds = (): QuoteFeedExtended[] => {
    return Array.from(this.activeQuoteFeeds.values());
  };

  public hasQuoteFeed = (symbol: Security): boolean => {
    return this.quoteFeeds.has(symbol);
  };

  public getQuoteFeed = (symbol: Security): QuoteFeedExtended | undefined => {
    const cached = this.quoteFeeds.get(symbol);
    if (cached && this.activeQuoteFeeds.has(cached)) {
      return cached;
    }

    //when cached feed is undefined check in active quote feeds set
    for (const feed of this.activeQuoteFeeds) {
      if (feed.getSecurities?.() === symbol) {
        this.quoteFeeds.set(symbol, feed);
        return feed;
      }
    }
    this.quoteFeeds.delete(symbol);
    return undefined;
  };
}
